export default __webpack_public_path__ + "static/grand_senora_desert_counterfeit-c5c44757326c896239d74eebe25e5b8d.png";